<p-toast position="top-center"></p-toast>
<form [formGroup]="formulario" (ngSubmit)="salvar()">
  <div class="p-grid">
      
    <div class="p-col-2" >
        <span style="font-weight: bolder">Nome do Servidor* </span> <br>
        <input  formControlName="nome" type="text" style="width:100%"  pInputText> 
        
      
        <div class="has-error" *ngIf="verificaValidTouched('nome')">Campo obrigatório</div> 
    </div>

    <div class="p-col-2" >
      <span style="font-weight: bolder">Telefone do Servidor* </span> <br>
      <input  formControlName="telefone" type="text" style="width:100%"  pInputText> 
      
    
      <div class="has-error" *ngIf="verificaValidTouched('telefone')">Campo obrigatório</div> 
  </div>

  <div class="p-col-2" >
    <span style="font-weight: bolder">Email do Servidor* </span> <br>
    <input  formControlName="email" type="text" style="width:100%"  pInputText> 
    
  
    <div class="has-error" *ngIf="verificaValidTouched('email')">Campo obrigatório</div> 
</div>

<div class="p-col-2" style="text-align: center;">
  <img *ngIf="imagemEscolhida" [src]="imagemEscolhida.completo" width="30px"> <br>
  <button pButton type="button" (click)="enviarArquivo()" label="Escolher Foto" class="ui-button-rounded ui-button-success"></button>
</div>

<div class="p-col-12">
  <button pButton type="submit"  label="Salvar" class="ui-button-rounded ui-button-primary"></button>
</div>
  </div>


</form>

<input id="ifile" type="file" hidden="true" (change)="escolheuArquivo($event)">

<br>
<p-table [value]="pessoas">
  <ng-template pTemplate="header">
      <tr>
          <th>Foto</th>
          <th>Nome</th>
          <th>Telefone</th>
          <th>Email</th>
          <th>Ações</th>
          
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-car>
      <tr>
          <td><img [src]="car.foto | pipeFoto" width="50px" style="border-radius: 50%;" > </td>
          <td>{{car.nome}}</td>
          <td>{{car.telefone}}</td>
          <td>{{car.email}}</td>
          <td><p-button icon="pi pi-chevron-circle-up" (click)="editar(car)"></p-button>
            <p-button style="margin-left:5px" icon="pi pi-users" (click)="vinculo(car)" class="ui-button-warning"></p-button>
          </td>
      </tr>
  </ng-template>
</p-table>


<p-dialog header="Vinculos" [(visible)]="mostrar">
  <div class="p-grid">
    <div class="p-col-12" style="text-align: center">
      <img *ngIf="psel" [src]="psel.foto | pipeFoto" width="40px" style="border-radius: 50%;"> 
    </div>
    <div class="p-col-12">
      {{psel?psel.nome:'-'}} <br>
      {{psel?psel.email:'-'}}
    </div>
    <div class="p-col-1">
      <p-checkbox [(ngModel)]="lider" binary="true"></p-checkbox> Líder
    </div>
    <div class="p-col-2">
      Função<br>
      <input  [(ngModel)]="funcao" type="text" style="width:100%"  pInputText> 
    </div>
    <div class="p-col-2">
      Origem<br>
      <input  [(ngModel)]="origem" type="text" style="width:100%"  pInputText> 
    </div>
    <div class="p-col-5">
      Grupo<br>
      <input  [(ngModel)]="grupo" type="text" style="width:100%"  pInputText> 
      
    </div>
    <div class="p-col-2">
      
      <p-button style="margin-left:5px" icon="pi pi-plus" (click)="adicionarVinculo()" class="ui-button-warning"></p-button>
      <p-button style="margin-left:5px" icon="pi pi-refresh" (click)="cancelar()" class="ui-button-warning"></p-button>
    </div>

    <div *ngIf="vinculos" class="p-col-12">
      <p-table [value]="vinculos">
        <ng-template pTemplate="header">
            <tr>
                <th>Função</th>
                <th>Grupo</th>
                <th>Origem</th>
                <th>Lider</th>
                <th>Ações</th>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-car>
            <tr>
                <td>{{car.funcao}}</td>
                <td>{{car.grupo}}</td>
                <td>{{car.origem}}</td>
                <td>{{car.lider}}</td>
                <td>
                  <p-button icon="pi pi-chevron-circle-up" (click)="editarVinculo(car)"></p-button>
                  <p-button style="margin-left:5px" icon="pi pi-times" (click)="excluirVinculo(car)" class="ui-button-warning"></p-button>
                  
                </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

